module.exports = __webpack_public_path__ + "img/生命礼仪系统1.f57f77b2.png";